import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { ALLOWED_COMBINATIONS, MODULES } from "./constants";
import { Module } from "./../../../constants";
import { capitalize } from "lodash-es";

function ClientCheckboxes() {
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation();
  const selectedModules = values.modules || [];

  const handleChange = module => {
    const updated = selectedModules.includes(module)
      ? selectedModules.filter(m => m !== module)
      : [...selectedModules, module];

    setFieldValue(
      "modules",
      ALLOWED_COMBINATIONS.some(
        allowed =>
          updated.length === allowed.length &&
          updated.every(item => allowed.includes(item))
      )
        ? updated
        : ALLOWED_COMBINATIONS[0]
    );
  };

  return (
    <>
      <FormLabel>{t("tool.clientForm.modules.name", "Modules")}</FormLabel>
      <FormGroup row>
        {MODULES.map(key => (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                checked={selectedModules.includes(key)}
                onChange={() => handleChange(key)}
                color="primary"
                disabled={key === Module.Analytics}
              />
            }
            label={capitalize(t(`tool.clientForm.modules.${key}`, key))}
          />
        ))}
      </FormGroup>
    </>
  );
}

export default ClientCheckboxes;
